
export const UCOperationType =
{
    operation_add: "add",
    operation_update: "update",
    operation_preview: "preview"
}